/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateQuoteAppendixRequest
 */
export interface UpdateQuoteAppendixRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteAppendixRequest
     */
    fileId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteAppendixRequest
     */
    fileName: string;
}

/**
 * Check if a given object implements the UpdateQuoteAppendixRequest interface.
 */
export function instanceOfUpdateQuoteAppendixRequest(value: object): value is UpdateQuoteAppendixRequest {
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function UpdateQuoteAppendixRequestFromJSON(json: any): UpdateQuoteAppendixRequest {
    return UpdateQuoteAppendixRequestFromJSONTyped(json, false);
}

export function UpdateQuoteAppendixRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateQuoteAppendixRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileId': json['fileId'],
        'fileName': json['fileName'],
    };
}

export function UpdateQuoteAppendixRequestToJSON(value?: UpdateQuoteAppendixRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileId': value['fileId'],
        'fileName': value['fileName'],
    };
}

